<div class="preview-modal-wrap">
  <div class="preview-modal-header">
    <span class="preview-file-name" [title]="data.fileName">{{ data.fileName }}</span>
    <button type="button" class="preview-close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-modal-body">

    <!-- Loading -->
    <div *ngIf="isLoading" class="preview-loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Image -->
    <img
      *ngIf="previewType === 'image' && safeUrl && !isLoading"
      [src]="safeUrl"
      [alt]="data.fileName"
      class="preview-image"
    />

    <!-- PDF -->
    <ngx-doc-viewer
      *ngIf="previewType === 'pdf' && docViewerUrl && !isLoading"
      [url]="docViewerUrl"
      viewer="pdf"
      style="width:100%; height:100%;"
    ></ngx-doc-viewer>

    <!-- Word (doc / docx) — mammoth rendered HTML -->
    <div
      *ngIf="previewType === 'word' && richHtml && !isLoading"
      class="word-preview-wrap rich-preview-wrap"
      [innerHTML]="richHtml"
    ></div>

    <!-- Excel / CSV — SheetJS rendered HTML table -->
    <div
      *ngIf="previewType === 'excel' && richHtml && !isLoading"
      class="excel-preview-wrap rich-preview-wrap"
      [innerHTML]="richHtml"
    ></div>

    <!-- Plain text -->
    <pre
      *ngIf="previewType === 'text' && textContent !== null && !isLoading"
      class="text-preview-wrap"
    >{{ textContent }}</pre>

    <!-- Unsupported -->
    <div *ngIf="previewType === 'unsupported' && !isLoading" class="preview-unsupported">
      <mat-icon class="unsupported-icon">insert_drive_file</mat-icon>
      <p class="unsupported-title">Preview not available</p>
      <p class="unsupported-sub">This file type cannot be previewed in the browser.</p>
    </div>

  </div>
</div>
